export default store => next => action => {
  try {
    return next(action);
  } catch (err) {
    // Defined globally at window scope in main app index.js
    // eslint-disable-next-line
    Rollbar.error(err);
    throw err;
  }
};
